export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9271.286ac855.jpg";